import go from "gojs";
import { replaceAllSpecialChar } from "@processEditor/CommNew";
const goMake = go.GraphObject.make;

function makeTextBlock(newOption={}) {
  let defaultOption = { 
    name : 'textValue' , 
    maxLines : 1 , 
    textAlign: 'center' , 
    font : `bold 13px 'fontello', 'Pretendard', 'NanumSquare', sans-serif` , 
    margin : new go.Margin(0,5,0,5) , // top , right , botton , left
    stretch: go.GraphObject.Fill,
    maxSize : new go.Size( 300 , 28 ) , 
    minSize : new go.Size( 107 , 28 ) , 
    overflow : go.TextBlock.OverflowEllipsis , 
    verticalAlignment : go.Spot.Center , 
    stroke : '#fff' , 
    position : go.Point.stringify , 
    // toolTip: goMake("ToolTip",
    //   goMake( go.TextBlock,
    //     {margin:4},
    //     new go.Binding("text","",toolTipHandler)
    //   )
    // ),
  };
  return goMake( go.TextBlock, Object.assign(defaultOption, newOption), new go.Binding("text"));
}

function makePanel(panel={}, shape={}, makes=[]) {
  return goMake(go.Panel, "Auto",
    { 
      name: "PANEL" , 
      margin : new go.Margin(0,0,0,0),
    },
    goMake( go.Shape , 'RoundedRectangle' , 
      { 
        name: 'NodeShape',
        stroke: 'transparent',
        strokeWidth:1,
        fill:"#6572A3",
        stretch: go.GraphObject.Fill,
        parameter1:5,
      } , 
    ),
    ...makes
  )
}

function makeButton(newOption={}){
  let defaultOption = {
    name : 'memoBtn' , 
    width : 21 , height : 25 , 
    alignment: go.Spot.TopLeft, 
    // alignment : new go.Spot ( 0, 0, 0, 0 ),
    alignmentFocus: go.Spot.Left,
    margin : new go.Margin(0,0,0,0) , // top , right , botton , left
    'ButtonBorder.stroke': null,
    'ButtonBorder.spot1': new go.Spot( 0,0,0,0 ), 
    'ButtonBorder.spot2': new go.Spot( 1,1,0,0 ), 
    '_buttonStrokeOver': null, 
    '_buttonFillNormal': "red", 
    '_buttonFillDisabled': "red", 
    '_buttonFillOver': null, 
    '_buttonFillPressed': null, 
    'ButtonBorder.figure':'Circle',
  }; 

  return goMake( 'Button' , Object.assign(defaultOption, newOption), 
    goMake( go.Picture , 
      `${ require('@/assets/icons/open-memo-top.svg')}` , 
      {
        width : 20.5 , 
        height : 24 ,  
      }
    ) , 
    new go.Binding( 'visible', 'data' , ( data ) => {
      if ( data.visible == true ) {
      }
      return data.visible ; 
    }).ofObject() , 
  ) 
}

function makeExpanderButton(newOption={}){
  let defaultOption = {
    name : 'TREEBUTTON' , 
    row : 1 , column : 1 , 
    alignment : go.Spot.Right , 
    alignmentFocus : go.Spot.Center , 
    'ButtonBorder.figure':'Circle',
    'ButtonBorder.fill': '#fff',
    'ButtonIcon.scale': 1.4 , 
  };

  return goMake("TreeExpanderButton",
    Object.assign(defaultOption, newOption={}),
    new go.Binding("visible", "isTreeLeaf", leaf =>{
      return false;
    } ).ofObject()
  )  // end TreeExpanderButton
}

function linkTemplate() {
  return goMake(go.Link,
    { routing: go.Link.Orthogonal, corner: 10 },
    goMake(go.Shape, { strokeWidth: 1, stroke:"#999", }),
    // goMake(go.Shape, { toArrow: "OpenTriangle", strokeWidth: 1, stroke:"#999", width:5, })
  )
}

function setCommitNodes(diagram, issues){
  diagram.layout.commitNodes = () => { // 노드 업데이트될 경우 진입 
    go.TreeLayout.prototype.commitNodes.call(diagram.layout)
    diagram.layout.network.vertexes.each( v => {
      if(v.node) {
        const { data , data : { P, H, display, category, parent }} = v.node ; 
        const shape = v.node.findObject('NodeShape'); 
        const text = v.node.findObject('textValue');
        if(shape) {
          shape.figure = "capsuleH";
          text.stroke = "#333";
          if( P === true ){
            shape.fill = "#E8F6F7";
            shape.stroke = "#19A4AD";
            text.stroke = "#0E0F0F";
          }else if( H === true ){
            shape.fill = "#cccccc";
          }else if( display !== undefined && display === false ){
            shape.fill = "#999";
          }else if( category == "SHORTVALUE" ){
            shape.fill = "#FFFFFF";
            shape.stroke = "#DDDDDD";
            text.stroke = "#333";
            text.textAlign = 'left';
            text.text = replaceAllSpecialChar(text.text);
          }else{
            const parentNode = issues.filter(o=>o.key===parent)[0];
            if( parentNode && parentNode["T"] === true ){
                shape.fill = "#FFFFFF";
                shape.stroke = "#DDDDDD";
            }else{
                shape.fill = "#FFFFFF";
                shape.stroke = "#DDDDDD";
            }
          }
          // console.log(  )
        } // end of if 
      } // end of if 
    }) ; // end of diagram 
  } ;
}


export {
  go, goMake, makePanel, makeButton, makeTextBlock, makeExpanderButton, linkTemplate, setCommitNodes
}